// import { listen } from 'quicklink';

const common = {
  init() {
    this.destroyBinded = this.destroy.bind(this);

    console.log('Common init');

    this.setUpListeners();
    this.setUpSlideAnims();
    this.setUpSplitTextAnims();
    // set up staggered fade in animations
    this.setUpStaggeredAnims();
  },

  setUpListeners() {
    //quicklink.js init
    // listen();
  },

  setUpSplitTextAnims() {
    const splitConfig = {
      lines: { duration: 0.8, stagger: 0.08 },
      words: { duration: 0.6, stagger: 0.06 },
      chars: { duration: 0.4, stagger: 0.01 }
    };
    const splitSelector = 'h1, h2, h3, h4, h5, h6';
    const fadeSelector = 'p, ul, ol, blockquote, table, figure, pre, dl, div';
    const textSelector = `${splitSelector}, ${fadeSelector}`;
    const fadeTags = fadeSelector.split(', ');

    document.querySelectorAll('[data-split="heading"]').forEach(container => {
      const type = container.dataset.splitReveal || 'lines';
      const typesToSplit =
        type === 'lines' ? ['lines'] :
        type === 'words' ? ['lines', 'words'] :
        ['lines', 'words', 'chars'];
      const textTargets = container.matches(splitSelector)
        ? [container]
        : Array.from(container.querySelectorAll(textSelector));

      if (!textTargets.length) {
        textTargets.push(container);
      }

      gsap.set(container, { autoAlpha: 1 });

      textTargets.forEach(text => {
        if (fadeTags.includes(text.tagName.toLowerCase())) {
          gsap.from(text, {
            autoAlpha: 0,
            duration: 0.6,
            ease: 'power1.out',
            scrollTrigger: {
              trigger: text,
              start: 'clamp(top 80%)',
              once: true
            }
          });

          return;
        }

        const content = document.createElement('span');
        content.className = 'split_content';

        while (text.firstChild) {
          content.appendChild(text.firstChild);
        }

        text.appendChild(content);
        gsap.set(text, { autoAlpha: 1 });

        SplitText.create(content, {
          type: typesToSplit.join(', '),
          mask: 'lines',
          autoSplit: true,
          tag: 'span',
          linesClass: 'line',
          wordsClass: 'word',
          charsClass: 'letter',
          onSplit: function(instance) {
            const targets = instance[type];
            const config = splitConfig[type];

            gsap.set(instance.lines.concat(instance.masks), { display: 'block' });
            gsap.set(instance.words.concat(instance.chars), { display: 'inline-block' });

            return gsap.from(targets, {
              yPercent: 110,
              duration: config.duration,
              stagger: config.stagger,
              ease: 'expo.out',
              scrollTrigger: {
                trigger: text,
                start: 'clamp(top 80%)',
                once: true
              }
            });
          }
        });
      });
    });
  },

  setUpStaggeredAnims() {
    document.querySelectorAll('.staggered_anim').forEach(parent => {
      const children = Array.from(parent.children);
      const staggerDelay = parseFloat(parent.dataset.staggerDelay);

      if (!children.length) {
        return;
      }

      gsap.from(children, {
        autoAlpha: 0,
        duration: 0.6,
        ease: 'power1.out',
        stagger: Number.isNaN(staggerDelay) ? 0.1 : staggerDelay,
        scrollTrigger: {
          trigger: parent,
          start: 'clamp(top 80%)',
          once: true
        }
      });
    });
  },

  setUpSlideAnims() {
    console.log('Setting up slide in animations');
    let $elsToAnimate = document.querySelectorAll(
      'main>section:not(.disable_slide_anim),'
      +'.client_victory_counter > .counter,'
      +'.client_victory_counter > .desc'
    );

    if (window.scrollY > 0) {
      // if the page was loaded scrolled in the middle,
      // skip the elements above the screen

      $elsToAnimate = Array.from($elsToAnimate)
        .filter($el => {
          const elRect = $el.getBoundingClientRect();

          if (elRect.top < 0) {
            gsap.set($el, {
              y: 0,
              opacity: 1
            });

            return false;
          } else {
            return true;
          }
        });
    }

    ScrollTrigger.batch($elsToAnimate,
      {
        id: 'slide_in',
        batchMax: window.innerWidth > 767 ? 45 : 20,
        fastScrollEnd: true,
        preventOverlaps: true,
        interval: 0.2, // time window (in seconds) for batching to occur.
        start: 'top 90%',
        end: 'bottom 10%',
        onEnter: $batchEls => {
          const tl = gsap.timeline({
            defaults: {
              duration: 2,
              ease: 'expo.out',
              overwrite: true
            }
          });
          let idOffset = 0;

          $batchEls.forEach(($el, id) => {
            let currId = id + idOffset;

            tl.to($el, {
              y: 0,
              opacity: 1
            }, currId * 0.2);
          });
        }
      });
  },

  resetSlideAnims() {
    this.destroySlideAnims();
    this.setUpSlideAnims();
  },

  destroySlideAnims() {
    const triggers = ScrollTrigger.getAll();

    triggers.forEach(trigger => {
      if (trigger.vars.id === 'slide_in') {
        trigger.kill();
        console.log('Destroying slide_in&parallax_img triggers');
      }
    });

    ScrollTrigger.refresh();
  },

  destroy() {
  }
};


export default common;
